<template>
  <div>
    <Applicant @titleFromChild="onTitleChanged"/>
  </div>
</template>

<script>
import Applicant from './Applicant.vue'

export default {
  name: 'home',
  data: function () {
    return {
    }
  },
  components: {
    Applicant
  },
  created () {

  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onTitleChanged (title) {
      this.$emit('titleFromChild', title)
    }
  }
}
</script>

<style lang="scss">
</style>
